<template>
  <div>
    <div class="container-fluid">
      <div class="llp-container-section heightcontainer">
        <top-header id="height2"></top-header>
        <main-menu id="height3"></main-menu>

        <div
          id="reporting"
          class="container-fluid menu-margin-top"
          style="padding-left: 0px; padding-right: 0px"
        >
          <div>
            <nav class="navbar navbar-expand-lg bg-info text-white">
              <span>
                <b>Payoff Quote</b>
              </span>
            </nav>
            <div class="alert-danger">
              <center>{{ checkapprovalmessage }}</center>
            </div>
            <div
              class="row row-cols-lg-6 row-cols-md-4 row-cols-sm-2 row-cols-2 p-2 align-items-baseline"
            >
              <div
                class="col-12 col-md-12 d-flex justify-content-lg-end align-items-center"
              >
                <label class="col-form-label col-form-label-sm required"
                  >Select Payoff Quote</label
                >
              </div>
              <div
                class="col-12 col-md-12 justify-content-end align-items-center mb-3 mb-lg-0 mb-md-3 mb-sm-3"
              >
                <multiselect
                  style="width: 100%"
                  data-vv-name="loan"
                  v-model="loan"
                  :options="loanlist"
                  placeholder="Select lease"
                  v-bind:value="loanlist.loanNumber"
                  v-bind:key="loanlist.loanNumber"
                  :custom-label="customLabel"
                  v-validate="'required'"
                  @input="reloadpayoffQuote"
                ></multiselect>
                <div v-if="errors.has('loan')" class="alert-danger">
                  {{ errors.first("loan") }}
                </div>
              </div>
              <div
                class="col-12 col-md-12 d-flex justify-content-lg-end align-items-center"
              >
                <label class="col-form-label col-form-label-sm required"
                  >Payment Type</label
                >
              </div>
              <div
                class="col-12 col-md-12 d-flex justify-content-end align-items-center mb-lg-0 mb-md-3 mb-sm-3"
              >
                <select
                  class="form-control input-sm"
                  v-model="selected"
                  @change="removecheckbox()"
                  id="checkapproval"
                  data-vv-name="paymenttype"
                >
                  <option
                    v-for="(paytype, index) in paymentTypeList"
                    v-bind:value="paytype.value"
                    v-bind:key="index"
                  >
                    {{ paytype.name }}
                  </option>
                </select>
                <div v-if="errors.has('paymenttype')" class="alert-danger">
                  {{ errors.first("paymenttype") }}
                </div>
              </div>
              <div
                class="col-12 col-md-12 col-lg-3 d-flex justify-content-lg-start align-items-center mb-3 mb-lg-0 mb-md-3 mb-sm-3"
              >
              <div class="d-flex align-items-center">
                  <input type="checkbox" v-model="ischecked" id="approvalCheck" />
                  <label for="approvalCheck" class="ml-1 mb-0">Check Supervisor Approval</label>
              </div>
              </div>
            </div>

            <center class="mt-2">
              <button
                type="submit"
                class="btn btn-secondary mb-2"
                @click="getPayoffQuote()"
              >
                Submit
              </button>
              &nbsp;&nbsp;&nbsp;
              <download-excel
                class="btn btn-secondary mb-2"
                name="Quotes.csv"
                title="Payoff Quotes"
                worksheet="Deals"
                :fetch="getPayoffQuotesToExport"
                :fields="
                  showTaxRows
                    ? payoff_quote_fields_export_with_sales
                    : payoff_quote_fields_export
                "
                type="csv"
                >Export csv</download-excel
              >&nbsp;&nbsp;&nbsp;
              <button
                class="btn btn-secondary mb-2"
                target="_blank"
                @click="generatePDF"
              >
                Generate PDF
              </button>
              &nbsp;&nbsp;&nbsp;
              <button
                class="btn btn-secondary mb-2"
                target="_blank"
                @click="generatepayoffLetter"
              >
                Payoff Quote Letter PDF</button
              >&nbsp;&nbsp;&nbsp;
              <button
                class="btn btn-secondary mb-2"
                target="_blank"
                @click="generatePayoffQuoteBreakdownPDF"
                :disabled="disableBreakdownButton"
                :style="{ cursor: disableBreakdownButton ? 'text' : 'pointer' }"
              >
                Payoff Breakdown</button
              >&nbsp;&nbsp;&nbsp;
              <button
                class="btn btn-secondary mb-2"
                target="_blank"
                @click="generatePayoffPacketPDF"
              >
                Payoff Packet</button
              >&nbsp;&nbsp;&nbsp;
            </center>
            <br />

            <div v-show="!showQuote">
              <div
                class="row row-cols-lg-6 row-cols-md-4 row-cols-sm-2 row-cols-2 p-2"
              >
                <div class="col d-flex justify-content-end align-items-center">
                  <label class="col-form-label col-form-label-sm"></label>
                </div>

                <div
                  class="col-12 col-md-12 d-flex justify-content-lg-end align-items-center"
                >
                  <label class="col-form-label col-form-label-sm">
                    <b>Borrower Name :</b>
                  </label>
                </div>

                <div
                  class="col-lg-6 justify-content-end align-items-center mb-3 mb-lg-0 mb-md-3 mb-sm-3"
                  v-for="(payoffQuote, index) in payoffQuote"
                  :key="index"
                >
                  <label class="col-form-label col-form-label-sm">{{
                    payoffQuote.borrowerName
                  }}</label>
                </div>
              </div>
              <div
                class="row row-cols-lg-6 row-cols-md-4 row-cols-sm-2 row-cols-2 p-2 justify-content-center"
              >
                <div
                  class="col-12 col-md-12 d-flex justify-content-lg-end align-items-center"
                >
                  <label class="col-form-label col-form-label-sm">
                    <b>Lease number :</b>
                  </label>
                </div>

                <div
                  class="col-12 col-md-12 justify-content-end align-items-center mb-3 mb-lg-0 mb-md-3 mb-sm-3"
                  v-for="(payoffQuote, index) in payoffQuote"
                  :key="index"
                >
                  <label class="col-form-label col-form-label-sm">{{
                    payoffQuote.loanNumber
                  }}</label>
                </div>
                <div
                  class="col-12 col-md-12 d-flex justify-content-lg-end align-items-center"
                >
                  <label class="col-form-label col-form-label-sm">
                    <b>Vehicle :</b>
                  </label>
                </div>

                <div
                  class="col-12 col-md-12 justify-content-end align-items-center mb-3 mb-lg-0 mb-md-3 mb-sm-3"
                  v-for="(payoffQuote, index) in payoffQuote"
                  :key="index"
                >
                  <label class="col-form-label col-form-label-sm">{{
                    payoffQuote.vehicle
                  }}</label>
                </div>
              </div>
              <div
                class="row row-cols-lg-6 row-cols-md-4 row-cols-sm-2 row-cols-2 p-2 justify-content-center"
              >
                <div
                  class="col-12 col-md-12 d-flex justify-content-lg-end align-items-center"
                >
                  <label class="col-form-label col-form-label-sm">
                    <b>
                      VIN
                      <span>:</span>
                    </b>
                  </label>
                </div>

                <div
                  class="col-12 col-md-12 justify-content-end align-items-center mb-3 mb-lg-0 mb-md-3 mb-sm-3"
                  v-for="(payoffQuote, index) in payoffQuote"
                  :key="index"
                >
                  <label class="col-form-label col-form-label-sm">{{
                    payoffQuote.vin
                  }}</label>
                </div>
                <div
                  class="col-12 col-md-12 d-flex justify-content-lg-end align-items-center"
                >
                  <label class="col-form-label col-form-label-sm">
                    <b>Payoff Request :</b>
                  </label>
                </div>

                <div
                  class="col-12 col-md-12 justify-content-end align-items-center mb-3 mb-lg-0 mb-md-3 mb-sm-3"
                  v-for="(payoffQuote, index) in payoffQuote"
                  :key="index"
                >
                  <label class="col-form-label col-form-label-sm">{{
                    payoffQuote.payoffRequest
                  }}</label>
                </div>
              </div>
              <br />
              <br />
              <div class="row p-2 justify-content-center">
                <div class="col-lg-3"></div>
                <div
                  class="col justify-content-end align-items-center mb-3 mb-lg-0 mb-md-3 mb-sm-3"
                >
                  <div class="table-responsive table-responsive-sm">
                    <table
                      class="table table-sm table-bordered table-striped"
                      v-for="(Quote, index) in payoffQuote"
                      :key="index"
                    >
                      <thead>
                        <tr class="table-danger">
                          <th v-for="(head, index) in heads" :key="index">
                            {{ head.name }}
                          </th>
                        </tr>
                      </thead>
                      <tr v-if="Quote.isFinanceLoan == 'Y'">
                        <td class="table-border">
                          LP Payoff
                        </td>
                        <td class="table-border-right">
                          <!-- {{ Quote.nextScheduledPaymentDate }} -->
                          {{ Quote.payoffAmount }}
                        </td>
                      </tr>
                      <tr v-if="Quote.isFinanceLoan == 'N'">
                        <td class="table-border">
                          <!-- Number of Scheduled ACH Payments -->
                          Total Amount of Payment Received
                        </td>
                        <td class="table-border-right">
                          <!-- {{ Quote.numberOfScheduledPayments }} -->
                          {{ Quote.totalAmountOfPaymentReceived }}
                        </td>
                      </tr>
                      <tr v-if="Quote.isFinanceLoan == 'N'">
                        <td class="table-border">
                          <!-- Next Scheduled Payment Date -->
                          Number of ACH Payments Made
                        </td>
                        <td class="table-border-right">
                          <!-- {{ Quote.nextScheduledPaymentDate }} -->
                          {{ Quote.numberOfACHPaymentMade }}
                        </td>
                      </tr>
                      <tr v-if="Quote.isFinanceLoan == 'N'">
                        <td class="table-border">
                          <!-- LLP Lease - Ending Balance -->
                          Last ACH Payment Date
                        </td>
                        <td class="table-border-right">
                          <!-- {{ Quote.endingBalance }} -->
                          {{ Quote.lastACHDate }}
                        </td>
                      </tr>
                      <tr v-if="Quote.isAPLegacy == 'Y' || Quote.isFinanceLoan == 'N'">
                        <td class="table-border">
                          <!-- LLP Lease - Next Month Interest -->
                          LLP Lease - Ending Balance
                        </td>
                        <td class="table-border-right">
                          <!-- {{ Quote.nextMonthInterest }} -->
                          {{ Quote.endingBalance }}
                        </td>
                      </tr>
                      <tr v-if="Quote.isAPLegacy == 'Y' || Quote.isFinanceLoan == 'N'">
                        <td class="table-border">
                          LLP Lease - Next Month Interest
                        </td>
                        <td class="table-border-right">
                          {{ Quote.nextMonthInterest }}
                        </td>
                      </tr>
                      <tr>
                        <td class="table-border">Per diem interest</td>
                        <td class="table-border-right">
                          {{ Quote.perDiemInterest }}
                        </td>
                      </tr>
                      <tr v-if="editNoOfDaysInterest">
                        <td class="table-border">Number of Days Interest</td>
                        <td class="table-border-right">
                          <div
                            class="d-flex justify-content-space-between align-items-center"
                          >
                            <input
                              v-model="noOfDaysInterest"
                              type="text"
                              class="special-instruct"
                              @input="onNoOfDaysInterestInput"
                            />
                            <button
                              class="ml-1 btn btn-sm btn-secondary"
                              @click="updateNoOfDaysInterest()"
                            >
                              Save
                            </button>
                          </div>
                        </td>
                      </tr>
                      <tr v-else>
                        <td class="table-border">Number of Days Interest</td>
                        <td class="table-border-right">
                          <div
                            class="d-flex justify-content-end align-items-center"
                          >
                            <div>
                              {{ noOfDaysInterest }}
                            </div>
                            <button
                              class="ml-1 btn btn-outline"
                              @click="editNoOfDaysInterestField()"
                              v-if="Quote.isFinanceLoan == 'N'"
                            >
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="16"
                                height="16"
                                fill="currentColor"
                                class="bi bi-pencil-square"
                                viewBox="0 0 16 16"
                              >
                                <path
                                  d="M15.502 1.94a.5.5 0 0 1 0 .706L14.459 3.69l-2-2L13.502.646a.5.5 0 0 1 .707 0l1.293 1.293zm-1.75 2.456-2-2L4.939 9.21a.5.5 0 0 0-.121.196l-.805 2.414a.25.25 0 0 0 .316.316l2.414-.805a.5.5 0 0 0 .196-.12l6.813-6.814z"
                                />
                                <path
                                  fill-rule="evenodd"
                                  d="M1 13.5A1.5 1.5 0 0 0 2.5 15h11a1.5 1.5 0 0 0 1.5-1.5v-6a.5.5 0 0 0-1 0v6a.5.5 0 0 1-.5.5h-11a.5.5 0 0 1-.5-.5v-11a.5.5 0 0 1 .5-.5H9a.5.5 0 0 0 0-1H2.5A1.5 1.5 0 0 0 1 2.5z"
                                />
                              </svg>
                            </button>
                          </div>
                        </td>
                      </tr>
                      <tr v-if="Quote.isFinanceLoan == 'Y'">
                        <td class="table-border">10 Day Interest Due</td>
                        <td class="table-border-right">
                          {{ Quote.tenDayInterestDue }}
                        </td>
                      </tr>
                      <tr v-if="Quote.isFinanceLoan == 'N'">
                        <td class="table-border">Total Interest Due</td>
                        <td class="table-border-right">
                          <!-- {{ Quote.totalInterestDue }} -->
                          {{ formatNumberInternational(totalInterestDue) }}
                        </td>
                      </tr>
                      <tr v-if="Quote.isFinanceLoan == 'N'">
                        <td class="table-border">
                          LLP - Lease Base Payment (not Tax)
                        </td>
                        <td class="table-border-right">
                          {{ Quote.leaseBasePayment }}
                        </td>
                      </tr>
                      <tr v-if="Quote.isFinanceLoan == 'N'">
                        <td class="table-border">
                          <!-- Delinquent Amount -->
                          Fees Due
                        </td>
                        <td class="table-border-right">
                          <!-- {{ Quote.delinquentAmount }} -->
                          {{ Quote.feesDue }}
                        </td>
                      </tr>
                      <tr v-if="Quote.isFinanceLoan == 'N'">
                        <td class="table-border">Fees Due at Payoff</td>
                        <td class="table-border-right">
                          {{ Quote.feesDueAtPayOff }}
                        </td>
                      </tr>
                      <tr v-if="Quote.isAPLegacy == 'Y' || Quote.isFinanceLoan == 'N'">
                        <td class="table-border">Payment Overage Applied to Account</td>
                        <td class="table-border-right">
                          {{ Quote.paymentOverageAppliedToAccount }}
                        </td>
                      </tr>
                      <tr v-if="Quote.isFinanceLoan == 'N'">
                        <td class="table-border">Is AP Legacy</td>
                        <td class="table-border-right">
                          {{ Quote.isAPLegacy }}
                        </td>
                      </tr>
                      <tr v-if="Quote.isAPLegacy == 'N' && Quote.isFinanceLoan == 'N'">
                        <td class="table-border">LLP Lease – Principal Balance</td>
                        <td class="table-border-right">
                          {{ Quote.principalBalance }}
                        </td>
                      </tr>
                      <tr v-if="Quote.isFinanceLoan == 'N'">
                        <td class="table-border">Unapplied Funds on Account</td>
                        <td class="table-border-right">
                          {{ Quote.unappliedFundsOnAccount }}
                        </td>
                      </tr>
                      <!-- start adding new rows for Faith and Jen -->
                      <tr v-if="showTaxRows && Quote.isFinanceLoan == 'N'">
                        <td class="table-border">Personal Property Taxes</td>
                        <td class="table-border-right">
                          <input
                            type="text"
                            class="no-arrows"
                            name="personalProTaxes"
                            min="0"
                            data-vv-as="Personal Property Taxes"
                            v-model.number="personalPropertyTaxes"
                            placeholder="Enter Tax Amount"
                            @input="handleEmptyValue"
                            @blur="formatInput(personalPropertyTaxes, 'personalPropertyTaxes')"
                          />
                        </td>
                      </tr>
                      <tr v-if="showTaxRows && Quote.isFinanceLoan == 'N'">
                        <td class="table-border">Sales Tax Percent</td>
                        <td class="table-border-right">
                          <input
                            type="number"
                            class="no-arrows"
                            name="salesTaxPercent"
                            min="0"
                            data-vv-as="Sales Tax Percent"
                            v-model.number="salesTaxPercent"
                            placeholder="Enter Sales Tax Percent"
                            @input="calculatSalesTax"
                          />
                        </td>
                      </tr>
                      <tr v-if="showTaxRows && Quote.isFinanceLoan == 'N'">
                        <td class="table-border">Calculated Sales Tax</td>
                        <td class="table-border-right">
                          <input
                            type="text"
                            class="no-arrows"
                            name="calculatedSalesTax"
                            v-model="calculatedSalesTax"
                            readonly
                            placeholder="Calculated Sales Tax"
                          />
                        </td>
                      </tr>
                      <tr v-if="showTaxRows">
                        <td class="table-border">Additional Charges</td>
                        <td class="table-border-right">
                          <input
                            type="text"
                            class="no-arrows"
                            name="additionalCharges"
                            min="0"
                            data-vv-as="Additional Charges"
                            v-model.number="additionalCharges"
                            placeholder="Enter Additional Charges"
                            @input="handleEmptyValue"
                            @blur="formatInput(additionalCharges, 'additionalCharges')"
                          />
                        </td>
                      </tr>
                      <!-- end adding new rows Faith and Jen -->
                      <tr v-if="Quote.isFinanceLoan == 'N'">
                        <td class="table-border">Early Out Processing Fee</td>
                        <td class="table-border-right">
                          {{ Quote.earlyOutProcessingFee }}
                        </td>
                      </tr>
                      <tr v-if="showTaxRows && Quote.isFinanceLoan == 'N'">
                        <td class="table-border">Ten Day Payoff Quote</td>
                        <td class="table-border-right">
                          {{ formatNumberInternational(newTenDaysPayoffQuote) }}
                        </td>
                      </tr>
                      <tr v-else-if="Quote.isFinanceLoan == 'Y'">
                        <td class="table-border">Ten Day Payoff Quote</td>
                        <td class="table-border-right">
                          {{ formatNumberInternational(getTenDayPayoffQuoteForFinanceLoan()) }}
                          <!-- {{ Quote.tenDaysPayoffQuote}} + {{(additionalCharges ? parseInput(additionalCharges) : 0) }} -->
                        </td>
                      </tr>
                      <tr v-else>
                        <td class="table-border">Ten Day Payoff Quote</td>
                        <td class="table-border-right">
                          {{ Quote.tenDaysPayoffQuote }}
                        </td>
                      </tr>
                      <tr>
                        <td class="table-border">Payoff Quote Good through</td>
                        <td class="table-border-right">
                          {{ Quote.payoffQuoteGoodthrough }}
                        </td>
                      </tr>
                      <tr v-if="(selected == '0' || selected == '1') && Quote.isFinanceLoan == 'N'">
                        <td class="row-bg-red">Early Termination Payments</td>
                        <td class="table-border-right">{{ selected }}</td>
                      </tr>
                      <tr v-if="(selected !== '0' && selected !== '1') && Quote.isFinanceLoan == 'N'">
                        <td class="table-border">Early Termination Payments</td>
                        <td class="table-border-right">
                          {{ Quote.earlyTerminationPayments }}
                        </td>
                      </tr>
                      <tr v-if="eidtInsturction && Quote.isFinanceLoan == 'N'">
                        <td class="table-border">
                          Special Payoff Instructions
                        </td>
                        <td class="table-border-right">
                          <div
                            class="d-flex justify-content-space-between align-items-center"
                          >
                            <textarea
                              v-model="specialPayOffInstruct"
                              class="special-instruct"
                              rows="1"
                              cols="50"
                            ></textarea>
                            <button
                              class="ml-1 btn btn-sm btn-secondary"
                              @click="updatePayoffQuote()"
                            >
                              Save
                            </button>
                          </div>
                        </td>
                      </tr>
                      <tr v-if="Quote.isFinanceLoan == 'N'">
                        <td class="table-border">
                          Special Payoff Instructions
                        </td>
                        <td class="table-border-right">
                          <div
                            class="d-flex justify-content-end align-items-center"
                          >
                            <div>
                              {{ specialPayOffInstruct }}
                            </div>
                            <button
                              class="ml-1 btn btn-outline"
                              @click="editPayoffQuote()"
                            >
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="16"
                                height="16"
                                fill="currentColor"
                                class="bi bi-pencil-square"
                                viewBox="0 0 16 16"
                              >
                                <path
                                  d="M15.502 1.94a.5.5 0 0 1 0 .706L14.459 3.69l-2-2L13.502.646a.5.5 0 0 1 .707 0l1.293 1.293zm-1.75 2.456-2-2L4.939 9.21a.5.5 0 0 0-.121.196l-.805 2.414a.25.25 0 0 0 .316.316l2.414-.805a.5.5 0 0 0 .196-.12l6.813-6.814z"
                                />
                                <path
                                  fill-rule="evenodd"
                                  d="M1 13.5A1.5 1.5 0 0 0 2.5 15h11a1.5 1.5 0 0 0 1.5-1.5v-6a.5.5 0 0 0-1 0v6a.5.5 0 0 1-.5.5h-11a.5.5 0 0 1-.5-.5v-11a.5.5 0 0 1 .5-.5H9a.5.5 0 0 0 0-1H2.5A1.5 1.5 0 0 0 1 2.5z"
                                />
                              </svg>
                            </button>
                          </div>
                        </td>
                      </tr>
                      <tr v-if="Quote.isFinanceLoan == 'N'">
                        <td class="table-border">Deferred Down Monthly Payment</td>
                        <td class="table-border-right">
                          {{ Quote.deferredDownMonthlyPayment }}
                        </td>
                      </tr>
                      <tr v-if="Quote.isFinanceLoan == 'N'">
                        <td class="table-border">Borrower State</td>
                        <td class="table-border-right">
                          {{ Quote.borrowerState }}
                        </td>
                      </tr>
                      <tr v-if="Quote.isFinanceLoan == 'Y'">
                        <td class="table-border">Included In LP Payoff - Unpaid Fees</td>
                        <td class="table-border-right">
                          {{ Quote.unpaidFees }}
                        </td>
                      </tr>
                      <tr>
                        <td class="table-border">SUBI Trust</td>
                        <td class="table-border-right">
                          {{ Quote.subitrust }}
                        </td>
                      </tr>
                      <tr>
                        <td class="table-border">Dealer Name</td>
                        <td class="table-border-right">
                          {{ Quote.sourceCompany }}
                        </td>
                      </tr>
                    </table>
                  </div>
                </div>
                <div class="col-lg-3"></div>
              </div>

              <br />
              <br />
            </div>

            <nav class="navbar navbar-expand-lg bg-info text-white">
              <span>
                <b>Download Payoff Quote For All Leases</b>
              </span>
            </nav>

            <br />

            <div
              class="row row-cols-lg-6 row-cols-md-4 row-cols-sm-2 row-cols-2 p-2"
            >
              <div class="col d-flex justify-content-end align-items-center">
                <button
                  class="btn btn-secondary"
                  title="Download CSV"
                  target="_blank"
                  @click="getPayoffQuoteList"
                >
                  Payoff quote
                </button>
              </div>
            </div>
            <br />
            <nav class="navbar navbar-expand-lg bg-info text-white">
              <span>
                <b>Upload Lease Amort Ending Balances</b>
              </span>
            </nav>
            <center>
              <span :style="msgcolor">{{ uploadingMessage }}</span>
            </center>
            <div
              class="row row-cols-lg-4 row-cols-md-4 row-cols-sm-2 row-cols-2 p-2"
            >
              <div
                class="col-12 col-md-12 d-flex justify-content-lg-end align-items-center"
              >
                <label class="col-form-label col-form-label-sm required"
                  >Upload Lease Amort Ending Balances</label
                >
              </div>
              <div
                class="col-12 col-md-12 justify-content-end align-items-center mb-3 mb-lg-0 mb-md-3 mb-sm-3"
              >
                <input
                  type="file"
                  class="form-control input-sm"
                  @change="onFileSelected"
                  id="uploadfile"
                />
                <span class="alert-danger">{{ message }}</span>
              </div>
              <div
                class="col-12 col-md-12 justify-content-lg-end align-items-center mb-3 mb-lg-0 mb-md-3 mb-sm-3"
              >
                <button
                  class="btn btn-secondary"
                  style="font-size: 14px"
                  @click="onUpload"
                >
                  Upload
                </button>
              </div>
            </div>
            <div id="myModal" class="modal">
              <!-- Modal content -->
              <div class="loader">
                <div class="cogs">
                  <div class="cog cog0">
                    <div class="bar"></div>
                    <div class="bar"></div>
                    <div class="bar"></div>
                    <div class="bar"></div>
                  </div>
                </div>
              </div>
              <!-- <div class="modal-content"> -->
              <!-- <div class="form-group">
            <div class="loader">
              <div class="cogs">
                <div class="cog cog0">
                  <div class="bar"></div>
                  <div class="bar"></div>
                  <div class="bar"></div>
                  <div class="bar"></div>
                </div>
              </div>
            </div>
             <div>
              <p style="margin-left:30px; margin-top:2px">please wait....</p>
            </div>
              </div>-->
              <!-- </div> -->
            </div>
            <div v-show="!showStatistics">
              <div
                class="row row-cols-lg-6 row-cols-md-4 row-cols-sm-2 row-cols-2 p-2"
              >
                <div class="col d-flex justify-content-end align-items-center">
                  <label class="col-form-label col-form-label-sm">
                    <b>Updated Records Statistics</b>
                  </label>
                </div>
              </div>
              <div
                class="row row-cols-lg-6 row-cols-md-4 row-cols-sm-2 row-cols-2 p-2"
              >
                <div class="col d-flex justify-content-end align-items-center">
                  <label class="col-form-label col-form-label-sm"
                    >Lease Records Inserted:</label
                  >
                </div>

                <div
                  class="col justify-content-end align-items-center mb-3 mb-lg-0 mb-md-3 mb-sm-3"
                >
                  <label class="col-form-label col-form-label-sm">{{
                    newRecords
                  }}</label>
                </div>
              </div>
              <div
                class="row row-cols-lg-6 row-cols-md-4 row-cols-sm-2 row-cols-2 p-2"
              >
                <div class="col d-flex justify-content-end align-items-center">
                  <label class="col-form-label col-form-label-sm"
                    >Lease Records Updated :</label
                  >
                </div>
                <div
                  class="col justify-content-end align-items-center mb-3 mb-lg-0 mb-md-3 mb-sm-3"
                >
                  <label class="col-form-label col-form-label-sm">{{
                    existedRecords
                  }}</label>
                </div>
              </div>
              <div
                class="row row-cols-lg-6 row-cols-md-4 row-cols-sm-2 row-cols-2 p-2 mb-3"
              >
                <div class="col d-flex justify-content-end align-items-center">
                  <label class="col-form-label col-form-label-sm"
                    >Total No of Lease Records:</label
                  >
                </div>

                <div
                  class="col justify-content-end align-items-center mb-3 mb-lg-0 mb-md-3"
                >
                  <label class="col-form-label col-form-label-sm">{{
                    totalRecords
                  }}</label>
                </div>
              </div>
            </div>
            <br />

            <br />
            <!-- <nav class="navbar navbar-expand-lg bg-info text-white">
              <span>
                <b>Upload Mini Mini Master File </b>
              </span>
            </nav> -->
            <!-- <center>
              <span :style="msgcolor">{{uploadingMiniLeaseLoaderMessage}}</span>
            </center> -->
            <!-- <div class="row row-cols-lg-4 row-cols-md-4 row-cols-sm-2 row-cols-2 p-2">
              <div class="col-12 col-md-12 d-flex justify-content-lg-end align-items-center">
                <label
                  class="col-form-label col-form-label-sm required"
                >Upload Mini Mini Master File</label>
              </div>
              <div
                class="col-12 col-md-12 justify-content-end align-items-center mb-3 mb-lg-0 mb-md-3 mb-sm-3"
              >
                <input
                  type="file"
                  class="form-control input-sm"
                  @change="onMiniFileSelected"
                  id="uploadMiniLeaseLoaderfile"
                />
                <span class="alert-danger">{{miniFileUploadMessage}}</span>
              </div>
              <div
                class="col-12 col-md-12 justify-content-lg-end align-items-center mb-3 mb-lg-0 mb-md-3 mb-sm-3"
              >
                <button class="btn btn-secondary" style="font-size:14px" @click="onMiniLeaseLoaderUpload">Upload</button>
              </div>
            </div> -->
            <div id="myModal" class="modal">
              <!-- Modal content -->
              <div class="loader">
                <div class="cogs">
                  <div class="cog cog0">
                    <div class="bar"></div>
                    <div class="bar"></div>
                    <div class="bar"></div>
                    <div class="bar"></div>
                  </div>
                </div>
              </div>
              <!-- <div class="modal-content"> -->
              <!-- <div class="form-group">
            <div class="loader">
              <div class="cogs">
                <div class="cog cog0">
                  <div class="bar"></div>
                  <div class="bar"></div>
                  <div class="bar"></div>
                  <div class="bar"></div>
                </div>
              </div>
            </div>
             <div>
              <p style="margin-left:30px; margin-top:2px">please wait....</p>
            </div>
              </div>-->
              <!-- </div> -->
            </div>

            <br />

            <br />
          </div>
        </div>
        <bottom-footer></bottom-footer>
      </div>
    </div>
  </div>
</template>
<script>
import TopHeader from '@/components/TopHeader.vue'
import BottomFooter from '@/components/BottomFooter.vue'
import MainMenu from '@/components/Menu.vue'
import httpdeal from '../js/http-dealstracking.js'
import util from '../js/common-utils'
import moment from 'moment'
import { hasAccess } from '../js - Local/permissions'

export default {
  components: { MainMenu, TopHeader, BottomFooter },
  data () {
    return {
      loan: '',
      loanlist: [],
      ischecked: '',
      payoffQuote: [],
      payoffQuoteList: [],
      showQuote: true,
      showStatistics: true,
      message: '',
      miniFileUploadMessage: '',
      checkapprovalmessage: '',
      selected: 'Standard',
      financeLoanAccess: false,
      totalInterestDue: 0,
      paymentTypeList: [
        { name: 'Standard', value: 'Standard' },
        { name: '0-Payment', value: '0' },
        { name: '1-Payment', value: '1' }
      ],
      existedRecords: '',
      newRecords: '',
      totalRecords: '',
      uploadingMessage: '',
      uploadingMiniLeaseLoaderMessage: '',
      selectedFile: '',
      selectedMiniFile: '',
      disableBreakdownButton: false,
      msgcolor: {
        color: 'black'
      },
      heads: [{ name: 'Details' }, { name: 'Value' }],
      payoff_quote_fields_export: {
        'Lease Number': 'loanNumber',
        'Borrower Name': 'borrowerName',
        Vehicle: 'vehicle',
        VIN: 'vin',
        'Payoff Request': 'payoffRequest',
        'Total Amount of Payment Received': 'totalAmountOfPaymentReceived',
        'Number of ACH Payments Made': 'numberOfACHPaymentMade',
        'Last ACH Payment Date': 'lastACHDate',
        // 'Numberof Scheduled ACH Payments': 'numberOfScheduledPayments',
        // 'Next Scheduled Payment Date': 'nextScheduledPaymentDate',
        'LLP Lease - Ending Balance': 'endingBalance',
        'LLP Lease - Next Month Interest': 'nextMonthInterest',
        'Per Diem Interest': 'perDiemInterest',
        'Number of Days Interest': 'numberOfdaysInterest',
        'Total Interest Due': 'totalInterestDue',
        'LLP - Lease Base Payment (not Tax)': 'leaseBasePayment',
        'Fees Due': 'feesDue',
        // 'Delinquent Amount': 'delinquentAmount',
        'Fees Due at Payoff': 'feesDueAtPayOff',
        'Payment Overage Applied to Account': 'paymentOverageAppliedToAccount',
        'Unapplied Funds on Account': 'unappliedFundsOnAccount',
        'Early Out Processing Fee': 'earlyOutProcessingFee',
        'Ten Day Payoff Quote': 'tenDaysPayoffQuote',
        'Payoff Quote Good through': 'payoffQuoteGoodthrough',
        'Early Termination Payments': 'earlyTerminationPayments',
        'Special Payoff Instructions': 'specialPayOffInstuctions',
        'Deferred Down Monthly Payment': 'deferredDownMonthlyPayment',
        'Borrower State': 'borrowerState',
        'SUBI Trust': 'subitrust',
        'Source Company': 'sourceCompany'
      },
      payoff_quote_fields_export_with_sales: {
        'Lease Number': 'loanNumber',
        'Borrower Name': 'borrowerName',
        'Vehicle': 'vehicle',
        'VIN': 'vin',
        'Payoff Request': 'payoffRequest',
        'Total Amount of Payment Received': 'totalAmountOfPaymentReceived',
        'Number of ACH Payments Made': 'numberOfACHPaymentMade',
        'Last ACH Payment Date': 'lastACHDate',
        // 'Numberof Scheduled ACH Payments': 'numberOfScheduledPayments',
        // 'Next Scheduled Payment Date': 'nextScheduledPaymentDate',
        'LLP Lease - Ending Balance': 'endingBalance',
        'LLP Lease - Next Month Interest': 'nextMonthInterest',
        'Per Diem Interest': 'perDiemInterest',
        'Number of Days Interest': 'numberOfdaysInterest',
        'Total Interest Due': 'totalInterestDue',
        'LLP - Lease Base Payment (not Tax)': 'leaseBasePayment',
        'Fees Due': 'feesDue',
        // 'Delinquent Amount': 'delinquentAmount',
        'Fees Due at Payoff': 'feesDueAtPayOff',
        'Payment Overage Applied to Account': 'paymentOverageAppliedToAccount',
        'Unapplied Funds on Account': 'unappliedFundsOnAccount',
        'Early Out Processing Fee': 'earlyOutProcessingFee',
        'Personal Property Taxes': 'personalPropertyTaxes',
        'Sales Tax Percent': 'salesTaxPercent',
        'Calculated Sales Tax': 'calculatedSalesTax',
        'Additional Charges': 'additionalCharges',
        'Ten Day Payoff Quote': 'newTenDaysPayoffQuote',
        'Payoff Quote Good through': 'payoffQuoteGoodthrough',
        'Early Termination Payments': 'earlyTerminationPayments',
        'Special Payoff Instructions': 'specialPayOffInstuctions',
        'Deferred Down Monthly Payment': 'deferredDownMonthlyPayment',
        'Borrower State': 'borrowerState',
        'SUBI Trust': 'subitrust',
        'Source Company': 'sourceCompany'
      },
      personalPropertyTaxes: null,
      salesTaxPercent: null,
      calculatedSalesTax: null,
      additionalCharges: null,
      showTaxRows: false,
      specialPayOffInstruct: '',
      // message: '',
      eidtInsturction: false,
      noOfDaysInterest: null,
      editNoOfDaysInterest: false,
      newTenDaysPayoffQuote: 0
    }
  },
  mounted () {
    if(!this.checkAccess('financeLoanPayoffAccess')) {
      this.financeLoanAccess = false
    } else {
      this.financeLoanAccess = true
    }
    this.fetchdata()
    this.myFunction()
    this.menuheight()
    this.isShowTaxRowsUser()
    this.setTenDaysPayoffQuote()
  },
  watch: {
    // Watch for changes in the 'loan' variable
    loan: function (newVal, oldVal) {
      // If a selection is made, clear the validation error
      if (newVal !== '') {
        this.$validator.errors.remove('loan')
      }
    }
  },
  methods: {
    formatInput (value, field) {
      let isNumeric = /^\d*\.?\d*$/.test(value)
      if (isNumeric) {
        let inputValue = parseFloat(value)
        if (!isNaN(inputValue)) {
          // Format the number with commas and two decimal places
          let formattedAmount = inputValue.toLocaleString('en-US', {
            style: 'currency',
            currency: 'USD',
            minimumFractionDigits: 2
          })
          // Update the personalPropertyTaxes data property with the formatted value
          // eslint-disable-next-line no-use-before-define, no-unexpected-multiline
          this[field] = formattedAmount
        }
      } else {
        if (value.startsWith('$')) {
          let validNum = /^\$?[0-9,.]+$/.test(value)
          if (validNum) {
            let tempNum = this.parseInput(value)
            this.formatInput(tempNum, field)
          } else {
            this[field] = null
          }
        } else {
          this[field] = null
        }
      }
    },
    parseInput (value) {
      if (typeof value !== 'string') {
        // If value is not a string, convert it to one
        value = String(value)
      }
      // Remove non-numeric characters except the dot (.)
      let numericValue = value.replace(/[^0-9.]/g, '')
      return Number(numericValue)
    },
    formatNumber (number) {
      // Convert number to have exactly 2 decimal places
      return Number(
        parseFloat(number)
          .toFixed(2)
          .replace(/(\.[^0-9]*?)0*$/, '$1')
      )
    },
    formatNumberInternational (number) {
      // Use built-in function toLocaleString for international formatting
      return '$' + parseFloat(number).toLocaleString('en-US', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      })
    },
    isZeroNullOrEmpty (input) {
      // Check if input is 0, null, or an empty string
      return input === 0 || input === null || input === ''
    },
    convertToDecimal (currencyValue) {
      // // Remove $ and , characters from the string and parse it to a floating-point number
      // return parseFloat(currencyValue.replace(/\$|,/g, ''))

      if (currencyValue == null || currencyValue === '') return 0;

      // Convert numbers to string safely
      let valueStr = currencyValue.toString();

      // Remove $ and , then parse to float
      let cleaned = valueStr.replace(/\$|,/g, '');
      const parsed = parseFloat(cleaned);

      // Return 0 if parsing fails (NaN)
      return isNaN(parsed) ? 0 : parsed;
    },
    handleEmptyValue () {
      this.setTenDaysPayoffQuote()
    },
    success (message) {
      this.$toasted.success(message).goAway(2000)
    },

    error (message) {
      this.$toasted.error(message).goAway(2000)
    },

    editPayoffQuote () {
      this.eidtInsturction = true
    },

    editNoOfDaysInterestField () {
      this.editNoOfDaysInterest = true
    },

    onNoOfDaysInterestInput (event) {
      const value = event.target.value.replace(/[^0-9]/g, '')
      this.noOfDaysInterest = value
      event.target.value = value
      this.totalInterestDue = this.formatNumber(this.convertToDecimal(this.payoffQuote[0].perDiemInterest)) * Number(value)
      if(this.payoffQuote[0].isFinanceLoan == 'N') {
        this.setTenDaysPayoffQuote()
      }
    },

    setDefaultSpecialInstruct () {
      if (this.payoffQuote[0].specialPayOffInstructions != null) {
        this.specialPayOffInstruct =
          this.payoffQuote[0].specialPayOffInstructions
      } else {
        this.specialPayOffInstruct = ''
      }
    },

    setDefaultNoOfDaysInterest () {
      if (this.payoffQuote[0].numberOfdaysInterest != null) {
        this.noOfDaysInterest = this.payoffQuote[0].numberOfdaysInterest
      } else {
        this.noOfDaysInterest = null
      }
      this.editNoOfDaysInterest = false
    },
    setTenDaysPayoffQuote () {
      // if (this.payoffQuote.length > 0 && this.payoffQuote[0].tenDaysPayoffQuote != null) {
        // eslint-disable-next-line no-unused-expressions
        // this.newTenDaysPayoffQuote =
        //   this.formatNumber(
        //     this.convertToDecimal(
        //       this.payoffQuote[0].tenDaysPayoffQuote != null
        //         ? this.payoffQuote[0].tenDaysPayoffQuote
        //         : 0
        //     )
        //   ) +
        //   (this.calculatedSalesTax == '' || this.calculatedSalesTax == null
        //     ? 0
        //     : this.parseInput(this.calculatedSalesTax)) +
        //   (this.personalPropertyTaxes == '' ||
        //   this.personalPropertyTaxes == null
        //     ? 0
        //     : this.parseInput(this.personalPropertyTaxes)) +
        //   (this.additionalCharges == '' || this.additionalCharges == null
        //     ? 0
        //     : this.parseInput(this.additionalCharges))
        // this.newTenDaysPayoffQuote = this.newTenDaysPayoffQuote.toFixed(2)
        if (this.payoffQuote.length > 0 && this.payoffQuote[0].tenDaysPayoffQuote != null) {
        let endingBalance = this.formatNumber(this.convertToDecimal(this.payoffQuote[0].endingBalance))
        // let totalInterestDue = this.formatNumber(this.convertToDecimal(this.payoffQuote[0].totalInterestDue))
        let totalInterestDue = this.formatNumber(this.convertToDecimal(this.totalInterestDue))
        let leaseBasePayment = this.formatNumber(this.convertToDecimal(this.payoffQuote[0].leaseBasePayment))
        let earlyTerminationPayments = this.formatNumber(this.payoffQuote[0].earlyTerminationPayments)
        let feesDue = this.formatNumber(this.convertToDecimal(this.payoffQuote[0].feesDue))
        let feesDueAtPayOff = this.formatNumber(this.convertToDecimal(this.payoffQuote[0].feesDueAtPayOff))
        let earlyOutProcessingFee = this.formatNumber(this.convertToDecimal(this.payoffQuote[0].earlyOutProcessingFee))
        let paymentOverageAppliedToAccount = this.formatNumber(this.convertToDecimal(this.payoffQuote[0].paymentOverageAppliedToAccount))
        let unappliedFundsOnAccount = this.formatNumber(this.convertToDecimal(this.payoffQuote[0].unappliedFundsOnAccount))
        let principalBal = this.formatNumber(this.convertToDecimal(this.payoffQuote[0].principalBalance || 0))

        if (this.payoffQuote[0].isAPLegacy == 'Y') {
        this.newTenDaysPayoffQuote = (endingBalance + totalInterestDue + (leaseBasePayment * earlyTerminationPayments) +
feesDue  + feesDueAtPayOff + 
(this.personalPropertyTaxes == '' ||
          this.personalPropertyTaxes == null
            ? 0
            : this.parseInput(this.personalPropertyTaxes)) + 
(this.calculatedSalesTax == '' || this.calculatedSalesTax == null
            ? 0
            : this.parseInput(this.calculatedSalesTax)) +
            (this.additionalCharges == '' || this.additionalCharges == null
            ? 0
            : this.parseInput(this.additionalCharges)) + earlyOutProcessingFee - paymentOverageAppliedToAccount - unappliedFundsOnAccount)

            this.newTenDaysPayoffQuote = this.newTenDaysPayoffQuote.toFixed(2)

        } else {
          this.newTenDaysPayoffQuote = (endingBalance + totalInterestDue + (leaseBasePayment * earlyTerminationPayments) +
feesDue  + feesDueAtPayOff + 
(this.personalPropertyTaxes == '' ||
          this.personalPropertyTaxes == null
            ? 0
            : this.parseInput(this.personalPropertyTaxes)) + 
(this.calculatedSalesTax == '' || this.calculatedSalesTax == null
            ? 0
            : this.parseInput(this.calculatedSalesTax)) +
            (this.additionalCharges == '' || this.additionalCharges == null
            ? 0
            : this.parseInput(this.additionalCharges)) + earlyOutProcessingFee - paymentOverageAppliedToAccount - unappliedFundsOnAccount)
        }
      } else {
        this.newTenDaysPayoffQuote = 0
      }
    },
    isShowTaxRowsUser () {
      if (
        sessionStorage.getItem('USERID') == 'emp1@pruvista.com' ||
        sessionStorage.getItem('USERID') == 'faith@luxuryleasepartners.com' ||
        sessionStorage.getItem('USERID') == 'jen@luxuryleasepartners.com' ||
        sessionStorage.getItem('USERID') == 'jeff.kline@luxuryleasepartners.com' ||
        sessionStorage.getItem('USERID') == 'ravi.khamla@unifiedinfotech.net' ||
        sessionStorage.getItem('USERID') == 'andrew.lesser@luxuryleasepartners.com' ||
        sessionStorage.getItem('USERID') == 'andrew@luxuryleasepartners.com'
      ) {
        this.showTaxRows = true
      } else {
        this.showTaxRows = true
      }
    },
    calculatSalesTax () {
      // Check if both numbers are valid before performing multiplication
      if (this.salesTaxPercent != null && this.payoffQuote.length > 0) {
        let tempSalesTaxPercent =
          this.salesTaxPercent == '' || this.salesTaxPercent == null
            ? 0
            : this.salesTaxPercent / 100
        // old formula for calculatedSalesTax :
        // this.calculatedSalesTax =
        //   this.formatNumber(
        //     this.convertToDecimal(this.payoffQuote[0].endingBalance)
        //   ) * tempSalesTaxPercent

        let endingBalance = this.formatNumber(this.convertToDecimal(this.payoffQuote[0].endingBalance))
        let totalInterestDue = this.formatNumber(this.convertToDecimal(this.payoffQuote[0].totalInterestDue))
        let delinquentAmount = this.formatNumber(this.convertToDecimal(this.payoffQuote[0].delinquentAmount))
        let unappliedFundsOnAccount = this.formatNumber(this.convertToDecimal(this.payoffQuote[0].unappliedFundsOnAccount))
        let leaseBasePayment = this.formatNumber(this.convertToDecimal(this.payoffQuote[0].leaseBasePayment))
        let earlyTerminationPayments = this.formatNumber(this.payoffQuote[0].earlyTerminationPayments)
        let paymentOverageAppliedToAccount = this.formatNumber(this.convertToDecimal(this.payoffQuote[0].paymentOverageAppliedToAccount))
        let principalBal = this.formatNumber(this.convertToDecimal(this.payoffQuote[0].principalBalance)) 
        console.log('endingBalance', endingBalance)
        console.log('totalInterestDue', totalInterestDue)
        console.log('delinquentAmount', delinquentAmount)
        console.log('unappliedFundsOnAccount', unappliedFundsOnAccount)
        console.log('leaseBasePayment', leaseBasePayment)
        console.log('earlyTerminationPayments', earlyTerminationPayments)
        console.log('tempSalesTaxPercent', tempSalesTaxPercent)

        // new formula for calculatedSalesTax :
         if (this.payoffQuote[0].isAPLegacy == 'Y') {
        this.calculatedSalesTax =
          // (
          //   endingBalance + totalInterestDue + delinquentAmount + unappliedFundsOnAccount + (leaseBasePayment * earlyTerminationPayments)
          // ) * tempSalesTaxPercent
          tempSalesTaxPercent*(
            endingBalance  - paymentOverageAppliedToAccount + totalInterestDue + (leaseBasePayment * earlyTerminationPayments) + unappliedFundsOnAccount
          )
      } else {
        this.calculatedSalesTax =
          tempSalesTaxPercent*(
            principalBal + totalInterestDue + (leaseBasePayment * earlyTerminationPayments) + unappliedFundsOnAccount
          )
      }

        this.calculatedSalesTax = this.formatNumber(this.calculatedSalesTax)
        this.formatInput(this.calculatedSalesTax, 'calculatedSalesTax')
      } else {
        this.calculatedSalesTax = null
      }
      this.setTenDaysPayoffQuote()
    },
    customLabel (option) {
      return `${option.loanNumber}`
    },
    myFunction () {
      var elmnt = document.getElementById('height2')
      var elmnt1 = document.getElementById('height3')
      var txt = elmnt.offsetHeight
      var width = elmnt.offsetWidth
      var txt1 = elmnt1.offsetHeight
      var ht = txt + txt1
      $('#reporting').css('margin-top', txt + txt1 + 3)
    },
    menuheight () {
      var elmnt = document.getElementById('height2')
      var txt = elmnt.offsetHeight
      $('#height3').css('margin-top', txt)
    },
    onFileSelected (event) {
      this.selectedFile = event.target.files[0]
    },
    onMiniFileSelected (event) {
      this.selectedMiniFile = event.target.files[0]
    },
    reloadpayoffQuote () {
      console.log('reloadpayoffQuote')
      this.copyOriginalPayoffQuote = {}
      this.payoffQuote = []
      this.showQuote = true
      this.selected = 'Standard'
      this.ischecked = ''
      this.checkapprovalmessage = ''
      let paymenttype = ''
          if (this.selected == 'Standard') {
            paymenttype = ''
          } else {
            paymenttype = this.selected
          }
      let payoffquote = {
              userName: this.$session.get('user_id'),
              userRole: this.$session.get('user_role'),
              loanNumber: this.loan.loanNumber,
              payment: paymenttype
            }
            httpdeal
              .post('/dataLinks/getPayoffQuote', payoffquote)
              .then((response) => {
                this.copyOriginalPayoffQuote = response.data[0]
                if (response.data[0].isFinanceLoan == 'Y') {
                  this.disableBreakdownButton = true
                } else {
                  this.disableBreakdownButton = false
                }
              })
              .catch((e) => {
                console.log('error', e)
                this.errors.push(e)
              })
    },
    checkSupervisorApproval () {
      if (this.selected == '0' || this.selected == '1') {
        if (this.ischecked == '') {
          this.checkapprovalmessage = 'Please check for supervisor approval'
        } else if (this.ischecked == true) {
          this.checkapprovalmessage = ''
        }
      }
    },
    checkAccess (permission) {
      return hasAccess(permission)
  },
    removecheckbox () {
      if (this.selected === 'Standard') {
        this.ischecked = ''
        this.checkapprovalmessage = ''
      }
    },
    onUpload () {
      this.uploadingMessage = ''
      if (document.getElementById('uploadfile').value != '') {
        this.message = ''
        var modal = document.getElementById('myModal')
        modal.style.display = 'block'
        const fd = new FormData()
        fd.append('payoffCSVFile', this.selectedFile, this.selectedFile.name)
        httpdeal
          .post('/dataLinks/uploadCSVFileLoanDetails', fd, {
            params: {
              userName: this.$session.get('user_id'),
              userRole: this.$session.get('user_role')
            },
            headers: { 'Content-Type': 'multipart/form-data' }
          })
          .then((response) => {
            modal.style.display = 'none'
            document.getElementById('uploadfile').value = null
            var status = response.data
            this.existedRecords = response.data.existedRecords
            this.newRecords = response.data.newRecords
            this.totalRecords = response.data.totalRecords
            this.showStatistics = false
          })
          .catch((e) => {
            console.log('Error in save data: ' + e)
            if (e.message == 'Request failed with status code 417') {
              this.uploadingMessage =
                'Could not upload the file: payoffCSVFile!'
              document.getElementById('uploadfile').value = null
            } else if (e.message == 'Request failed with status code 400') {
              this.uploadingMessage = 'Please upload a csv file!'
              document.getElementById('uploadfile').value = null
            } else {
              this.uploadingMessage = ''
            }
            this.failure = true
            modal.style.display = 'none'
          })
      } else {
        this.message = 'choose a csv file'
        this.uploadingMessage = ''
      }
    },
    onMiniLeaseLoaderUpload () {
      this.uploadingMiniLeaseLoaderMessage = ''
      if (document.getElementById('uploadMiniLeaseLoaderfile').value != '') {
        this.miniFileUploadMessage = ''
        var modal = document.getElementById('myModal')
        modal.style.display = 'block'
        const fd = new FormData()
        fd.append(
          'miniLeaseLoaderCSVFile',
          this.selectedMiniFile,
          this.selectedMiniFile.name
        )
        httpdeal
          .post('/dataLinks/uploadCSVFileMiniLeaseLoader', fd, {
            params: {
              userName: this.$session.get('user_id'),
              userRole: this.$session.get('user_role')
            },
            headers: { 'Content-Type': 'multipart/form-data' }
          })
          .then((response) => {
            modal.style.display = 'none'
            document.getElementById('uploadMiniLeaseLoaderfile').value = null
          })
          .catch((e) => {
            console.log('Error in save data: ' + e)
            if (e.message == 'Request failed with status code 417') {
              this.uploadingMiniLeaseLoaderMessage =
                'Could not upload the file: payoffCSVFile!'
              document.getElementById('uploadMiniLeaseLoaderfile').value = null
            } else if (e.message == 'Request failed with status code 400') {
              this.uploadingMiniLeaseLoaderMessage =
                'Please upload a csv file!'
              document.getElementById('uploadMiniLeaseLoaderfile').value = null
            } else {
              this.uploadingMiniLeaseLoaderMessage = ''
            }
            this.failure = true
            modal.style.display = 'none'
          })
      } else {
        this.miniFileUploadMessage = 'choose a csv file'
        this.uploadingMiniLeaseLoaderMessage = ''
      }
    },
    fetchdata () {
      this.retrieveLoanNumber()
    },

    retrieveLoanNumber: function () {
      httpdeal
        .get('/dataLinks/getListOfLeaseNumbers', {
          params: {
            userName: this.$session.get('user_id'),
            userRole: this.$session.get('user_role'),
            financeLoanAccess: this.financeLoanAccess
          }
        })
        .then((response) => {
          this.loanlist = response.data
        })
        .catch((e) => {
          this.errors.push(e)
        })
    },

    getPayoffQuote () {
      this.checkSupervisorApproval()
      if (this.checkapprovalmessage === '') {
        this.$validator.validateAll().then(() => {
          let paymenttype = ''
          if (this.selected == 'Standard') {
            paymenttype = ''
          } else {
            paymenttype = this.selected
          }
          console.log(this.errors)
          if (!this.errors.any()) {
            // eslint-disable-next-line no-unused-expressions
            // reseting new fields value
            this.personalPropertyTaxes = null
            this.salesTaxPercent = null
            this.calculatedSalesTax = null
            this.additionalCharges = null
            this.totalInterestDue = 0
            this.newTenDaysPayoffQuote = 0
            // end reseting new fields value
            let payoffquote = {
              userName: this.$session.get('user_id'),
              userRole: this.$session.get('user_role'),
              loanNumber: this.loan.loanNumber,
              payment: paymenttype
            }
            httpdeal
              .post('/dataLinks/getPayoffQuote', payoffquote)
              .then((response) => {
                this.payoffQuote = response.data
                this.totalInterestDue = this.payoffQuote.length
                  ? this.formatNumber(this.convertToDecimal(this.payoffQuote[0].totalInterestDue))
                  : 0
                this.setDefaultSpecialInstruct()
                this.setDefaultNoOfDaysInterest()
                this.setTenDaysPayoffQuote()
                this.showQuote = false
              })
              .catch((e) => {
                console.log('error', e)
                this.errors.push(e)
              })
          }
        })
      }
    },

    async updatePayoffQuote () {
      let payoffquote = {
        specialPayOffInstructions: this.specialPayOffInstruct
      }
      httpdeal
        .post(
          `/dataLinks/updatePayoffQuote/specialInstructions?loanNumber=${this.loan.loanNumber}`,
          payoffquote
        )
        .then((response) => {
          this.success('Special Instruction updated successfully!!')
          this.eidtInsturction = false
        })
        .catch((e) => {
          this.errors.push(e)
        })
    },

    async updateNoOfDaysInterest () {
      let payload = {
        numberOfdaysInterest: this.noOfDaysInterest === '' || this.noOfDaysInterest == null
          ? null
          : Number(this.noOfDaysInterest)
      }
      httpdeal
        .post(
          `/dataLinks/updatePayoffQuote/noOfDaysInterest?loanNumber=${this.loan.loanNumber}`,
          payload
        )
        .then((response) => {
          this.success('Number of Days Interest updated successfully!!')
          this.editNoOfDaysInterest = false
          if (this.payoffQuote.length > 0) {
            this.payoffQuote[0].numberOfdaysInterest = this.noOfDaysInterest
          }
        })
        .catch((e) => {
          this.errors.push(e)
        })
    },

    async getPayoffQuotesToExport () {
      this.checkSupervisorApproval()
      if (this.checkapprovalmessage === '') {
        let paymenttype = ''
        if (this.selected == 'Standard') {
          paymenttype = ''
        } else {
          paymenttype = this.selected
        }
        let result = await this.$validator.validate()
        let payoffquote = {
          userName: this.$session.get('user_id'),
          userRole: this.$session.get('user_role'),
          loanNumber: this.loan.loanNumber,
          payment: paymenttype
        }
        if (result && !this.errors.any()) {
          const response = await httpdeal.post(
            '/dataLinks/getPayoffQuote',
            payoffquote
          )
          // eslint-disable-next-line no-lone-blocks
          {
            if (this.showTaxRows) {
              const salesObj = {
                personalPropertyTaxes: !this.isZeroNullOrEmpty(this.personalPropertyTaxes) ? this.personalPropertyTaxes : '$ 0.00',
                salesTaxPercent: !this.isZeroNullOrEmpty(this.salesTaxPercent) ? this.salesTaxPercent + '%' : '0.00%',
                calculatedSalesTax: !this.isZeroNullOrEmpty(this.calculatedSalesTax) ? this.calculatedSalesTax : '$ 0.00',
                additionalCharges: !this.isZeroNullOrEmpty(this.additionalCharges) ? this.additionalCharges : '$ 0.00',
                // newTenDaysPayoffQuote: !this.isZeroNullOrEmpty(this.newTenDaysPayoffQuote) ? this.formatNumberInternational(this.formatNumber(this.newTenDaysPayoffQuote)) : '$ 0.00'
                newTenDaysPayoffQuote: this.copyOriginalPayoffQuote.isFinanceLoan == 'Y' ? this.formatNumberInternational(this.getCopyOriginalTenDayPayoffQuoteForFinanceLoan()) : !this.isZeroNullOrEmpty(this.newTenDaysPayoffQuote) ? this.formatNumberInternational(this.formatNumber(this.newTenDaysPayoffQuote)) : this.copyOriginalPayoffQuote.tenDaysPayoffQuote
              }
              console.log('salesObj', this.copyOriginalPayoffQuote)
              const tempArray = [{ ...response.data[0], ...salesObj }]
              return tempArray
            } else {
              return response.data
            }
          }
        }
      }
    },

    getPayoffQuoteList () {
      httpdeal
        .get('/dataLinks/getPayoffQuoteList', {
          params: {
            userName: this.$session.get('user_id'),
            userRole: this.$session.get('user_role'),
            financeLoanAccess: this.financeLoanAccess
          }
        })
        .then((response) => {
          window.open(response.data, '_target')
        })
        .catch((e) => {
          this.errors.push(e)
        })
    },

    generatePDF () {
      this.checkSupervisorApproval()
      if (this.checkapprovalmessage === '') {
        this.$validator.validateAll().then(() => {
          console.log(this.errors)
          let paymenttype = ''
          if (this.selected == 'Standard') {
            paymenttype = ''
          } else {
            paymenttype = this.selected
          }
          if (!this.errors.any()) {
            const normalUser = {
              userName: this.$session.get('user_id'),
              userRole: this.$session.get('user_role'),
              loanNumber: this.loan.loanNumber,
              payment: paymenttype
            }
            const specialUser = {
              userName: this.$session.get('user_id'),
              userRole: this.$session.get('user_role'),
              loanNumber: this.loan.loanNumber,
              payment: paymenttype,
              personalPropertyTaxes:
                 !this.isZeroNullOrEmpty(this.personalPropertyTaxes)
                   ? this.personalPropertyTaxes
                   : '$0.00',
              salesTaxPercent:
                !this.isZeroNullOrEmpty(this.salesTaxPercent)
                  ? this.salesTaxPercent + '%'
                  : '0.00 %',
              calculatedSalesTax:
                !this.isZeroNullOrEmpty(this.calculatedSalesTax)
                  ? this.calculatedSalesTax
                  : '$0.00',
              additionalCharges:
                !this.isZeroNullOrEmpty(this.additionalCharges)
                  ? this.additionalCharges
                  : '$0.00',
              // tenDayPayOff:
              //   !this.isZeroNullOrEmpty(this.newTenDaysPayoffQuote)
              //     ? this.formatNumberInternational(this.formatNumber(this.newTenDaysPayoffQuote))
              //     : '$0.00'
              tenDayPayOff: this.copyOriginalPayoffQuote.isFinanceLoan == 'Y' ? this.formatNumberInternational(this.getCopyOriginalTenDayPayoffQuoteForFinanceLoan()) : !this.isZeroNullOrEmpty(this.newTenDaysPayoffQuote)
                  ? this.formatNumberInternational(this.formatNumber(this.newTenDaysPayoffQuote))
                  : this.copyOriginalPayoffQuote.tenDaysPayoffQuote
            }
            httpdeal
              .get('/dataLinks/getPayOffPDF', {
                params: this.showTaxRows ? specialUser : normalUser
              })
              .then((response) => {
                console.log('response')
                console.log(response)
                window.open(response.data, '_target')
              })
              .catch((e) => {
                this.errors.push(e)
              })
          }
        })
      }
    },
    generatepayoffLetter () {
      this.checkSupervisorApproval()
      if (this.checkapprovalmessage === '') {
        this.$validator.validateAll().then(() => {
          console.log(this.errors)
          let paymenttype = ''
          if (this.selected == 'Standard') {
            paymenttype = ''
          } else {
            paymenttype = this.selected
          }
          if (!this.errors.any()) {
            const normalUser = {
              userName: this.$session.get('user_id'),
              userRole: this.$session.get('user_role'),
              loanNumber: this.loan.loanNumber,
              payment: paymenttype
            }
            const specialUser = {
              userName: this.$session.get('user_id'),
              userRole: this.$session.get('user_role'),
              loanNumber: this.loan.loanNumber,
              payment: paymenttype,
              personalPropertyTaxes:
                 !this.isZeroNullOrEmpty(this.personalPropertyTaxes)
                   ? this.personalPropertyTaxes
                   : '$0.00',
              salesTaxPercent:
                !this.isZeroNullOrEmpty(this.salesTaxPercent)
                  ? this.salesTaxPercent + '%'
                  : '0.00 %',
              calculatedSalesTax:
                !this.isZeroNullOrEmpty(this.calculatedSalesTax)
                  ? this.calculatedSalesTax
                  : '$0.00',
              additionalCharges:
                !this.isZeroNullOrEmpty(this.additionalCharges)
                  ? this.additionalCharges
                  : '$0.00',
              // tenDayPayOff:
              //   !this.isZeroNullOrEmpty(this.newTenDaysPayoffQuote)
              //     ? this.formatNumberInternational(this.formatNumber(this.newTenDaysPayoffQuote))
              //     : '$0.00'
              tenDayPayOff: this.copyOriginalPayoffQuote.isFinanceLoan == 'Y' ? this.formatNumberInternational(this.getCopyOriginalTenDayPayoffQuoteForFinanceLoan()) : !this.isZeroNullOrEmpty(this.newTenDaysPayoffQuote)
                  ? this.formatNumberInternational(this.formatNumber(this.newTenDaysPayoffQuote))
                  : this.copyOriginalPayoffQuote.tenDaysPayoffQuote
            }
            httpdeal
              .get('/dataLinks/getPayoffLetter', {
                params: this.showTaxRows ? specialUser : normalUser
              })
              .then((response) => {
                window.open(response.data, '_target')
              })
              .catch((e) => {
                this.errors.push(e)
              })
          }
        })
      }
    },
    generatePayoffQuoteBreakdownPDF () {
      this.checkSupervisorApproval()
      if (this.checkapprovalmessage === '') {
        this.$validator.validateAll().then(() => {
          console.log(this.errors)
          let paymenttype = ''
          if (this.selected == 'Standard') {
            paymenttype = ''
          } else {
            paymenttype = this.selected
          }
          if (!this.errors.any()) {
            const normalUser = {
              userName: this.$session.get('user_id'),
              userRole: this.$session.get('user_role'),
              loanNumber: this.loan.loanNumber,
              payment: paymenttype
            }
            console.log(typeof (this.personalPropertyTaxes))
            console.log(this.personalPropertyTaxes)
            const specialUser = {
              userName: this.$session.get('user_id'),
              userRole: this.$session.get('user_role'),
              loanNumber: this.loan.loanNumber,
              payment: paymenttype,
              personalPropertyTaxes:
                 !this.isZeroNullOrEmpty(this.personalPropertyTaxes)
                   ? this.personalPropertyTaxes
                   : '$0.00',
              salesTaxPercent:
                !this.isZeroNullOrEmpty(this.salesTaxPercent)
                  ? this.salesTaxPercent + '%'
                  : '0.00 %',
              calculatedSalesTax:
                !this.isZeroNullOrEmpty(this.calculatedSalesTax)
                  ? this.calculatedSalesTax
                  : '$0.00',
              additionalCharges:
                !this.isZeroNullOrEmpty(this.additionalCharges)
                  ? this.additionalCharges
                  : '$0.00',
              // tenDayPayOff:
              //   !this.isZeroNullOrEmpty(this.newTenDaysPayoffQuote)
              //     ? this.formatNumberInternational(this.formatNumber(this.newTenDaysPayoffQuote))
              //     : '$0.00'
              tenDayPayOff: this.copyOriginalPayoffQuote.isFinanceLoan == 'Y' ? this.formatNumberInternational(this.getCopyOriginalTenDayPayoffQuoteForFinanceLoan()) : !this.isZeroNullOrEmpty(this.newTenDaysPayoffQuote)
                  ? this.formatNumberInternational(this.formatNumber(this.newTenDaysPayoffQuote))
                  : this.copyOriginalPayoffQuote.tenDaysPayoffQuote
            }
            httpdeal
              .get('/dataLinks/getPayoffBreakdown', {
                params: this.showTaxRows ? specialUser : normalUser
              })
              .then((response) => {
                window.open(response.data, '_target')
              })
              .catch((e) => {
                this.errors.push(e)
              })
          }
        })
      }
    },
    getTenDayPayoffQuoteForFinanceLoan () {
        return Number(this.parseInput(this.payoffQuote[0].tenDaysPayoffQuote)) + Number(this.additionalCharges ? this.parseInput(this.additionalCharges) : 0)
    },
    getCopyOriginalTenDayPayoffQuoteForFinanceLoan () {
        return Number(this.parseInput(this.copyOriginalPayoffQuote.tenDaysPayoffQuote)) + Number(this.additionalCharges ? this.parseInput(this.additionalCharges) : 0)
    },
    generatePayoffPacketPDF () {
      this.checkSupervisorApproval()
      this.payoffQuoteMessage = ''
      if (this.checkapprovalmessage === '') {
        this.$validator.validateAll().then(() => {
          console.log(this.errors)
          let paymenttype = ''
          if (this.selected == 'Standard') {
            paymenttype = ''
          } else {
            paymenttype = this.selected
          }
          if (!this.errors.any()) {
            const normalUser = {
              userName: this.$session.get('user_id'),
              userRole: this.$session.get('user_role'),
              loanNumber: this.loan.loanNumber,
              payment: paymenttype
            }
            const specialUser = {
              userName: this.$session.get('user_id'),
              userRole: this.$session.get('user_role'),
              loanNumber: this.loan.loanNumber,
              payment: paymenttype,
              tenDayPayOff:
                !this.isZeroNullOrEmpty(this.newTenDaysPayoffQuote)
                  ? this.formatNumberInternational(this.formatNumber(this.newTenDaysPayoffQuote) - this.parseInput(this.calculatedSalesTax))
                  : '$0.00'
            }
            httpdeal
              .get('/dataLinks/getPayoffPacket', {
                params: this.showTaxRows ? specialUser : normalUser
              })
              .then((response) => {
                // console.log(response.data)
                if (
                  response.data !=
                  'Payoff tool will not print letter as this lease has multiple in vehicle information.'
                ) {
                  window.open(response.data, '_target')
                } else {
                  this.payoffQuoteMessage =
                    'Payoff tool will not print letter as this lease has multiple in vehicle information.'
                }
              })
              .catch((e) => {
                this.errors.push(e)
              })
          }
        })
      }
    }
  },
  created () {
    window.addEventListener('resize', this.myFunction)
    window.addEventListener('resize', this.menuheight)
  }
}
</script>
<style scoped>
.maxwidth {
  max-width: 6%;
  margin-top: 10px;
}

.row-bg-red {
  background-color: Red;
  border: 1px solid #dddddd;
  text-align: left;
  padding: 8px 100px 8px 8px;
}

.no-arrows::-webkit-inner-spin-button,
.no-arrows::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

.no-arrows {
  padding: 5px;
  border: 1px solid #ccc;
  border-radius: 4px;
  text-align: right;
}

.special-instruct {
  padding: 5px;
  border: 1px solid #ccc;
  border-radius: 4px;
  text-align: right;
}
</style>
